export const PACTS = [
  {
    id: "pact_aa",
    wikiCode: "AA",
    name: "Regenerate",
    summary: "50% chance to Regenerate runes, ammo and charges",
    desc: "",
    branch: "General",
    x: 723, y: 473,
    requires: [],
    skills: {},
    effect: {},
  },

  {
    id: "pact_b1",
    wikiCode: "B1",
    name: "????????",
    summary: "Whenever your combat spells Regenerate runes, your Magic level is boosted by 1 for 30 ticks (18s).",
    desc: "This boost cannot exceed 10 Magic levels and additional triggers reset the duration",
    branch: "Magic",
    x: 210, y: 152,
    requires: ["pact_aa"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_b2",
    wikiCode: "B2",
    name: "????????",
    summary: "Whenever you Regenerate ammo, you have a +25% chance to fire a Ranged echo against the enemy",
    desc: "",
    branch: "Range",
    x: 723, y: 753,
    requires: ["pact_aa"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_b3",
    wikiCode: "B3",
    name: "????????",
    summary: "Your minimum hit when attacking with a melee weapon is increased by 3.",
    desc: "This minimum hit is further increased by 3 for each additional tile between you and the target",
    branch: "Melee",
    x: 1203, y: 152,
    requires: ["pact_aa"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_ba",
    wikiCode: "BA",
    name: "????????",
    summary: "+5% chance to Regenerate runes, ammo and charges",
    desc: "",
    branch: "General",
    x: 723, y: -525,
    requires: ["pact_aa", "pact_g11"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_bb",
    wikiCode: "BB",
    name: "????????",
    summary: "+5% chance to Regenerate runes, ammo and charges",
    desc: "",
    branch: "General",
    x: -414, y: 712,
    requires: ["pact_aa", "pact_f11", "pact_h5"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_bc",
    wikiCode: "BC",
    name: "????????",
    summary: "+5% chance to Regenerate runes, ammo and charges",
    desc: "",
    branch: "General",
    x: 1863, y: 712,
    requires: ["pact_aa", "pact_g12", "pact_h8"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_c1",
    wikiCode: "C1",
    name: "????????",
    summary: "Whenever your combat spells Regenerate air runes, you have a 15% chance to restore 1 prayer point per rune regenerated",
    desc: "",
    branch: "Magic",
    x: -591, y: 135,
    requires: ["pact_b1"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_c2",
    wikiCode: "C2",
    name: "????????",
    summary: "Whenever your combat spells Regenerate water runes, you're healed for 1 per rune regenerated",
    desc: "",
    branch: "Magic",
    x: -394, y: -47,
    requires: ["pact_b1"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_c3",
    wikiCode: "C3",
    name: "????????",
    summary: "Whenever your combat spells Regenerate fire runes, the damage of your next spell hit is increased by 1 per rune regenerated",
    desc: "",
    branch: "Magic",
    x: 22, y: -454,
    requires: ["pact_b1"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_c4",
    wikiCode: "C4",
    name: "????????",
    summary: "Whenever your combat spells Regenerate earth runes, your Defence level is boosted by 1 per rune regenerated for 30 ticks (18s)",
    desc: "",
    branch: "Magic",
    x: 200, y: -640,
    requires: ["pact_b1"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_ca",
    wikiCode: "CA",
    name: "????????",
    summary: "+15% accuracy in all combat styles",
    desc: "",
    branch: "Ranged",
    x: -864, y: -137,
    requires: ["pact_c1"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_cb",
    wikiCode: "CB",
    name: "????????",
    summary: "+15% accuracy in all combat styles",
    desc: "",
    branch: "Ranged",
    x: -449, y: -545,
    requires: ["pact_c2", "pact_c3"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_cc",
    wikiCode: "CC",
    name: "????????",
    summary: "+15% accuracy in all combat styles",
    desc: "",
    branch: "Ranged",
    x: -56, y: -908,
    requires: ["pact_c4"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_d1",
    wikiCode: "D1",
    name: "Thorns",
    summary: "While you have a shield equipped you gain the Thorns effect.",
    desc: "Whenever you're attacked enemies will be instantly hit with 3 melee damage",
    branch: "Melee",
    x: 1211, y: -629,
    requires: ["pact_b3"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_d2",
    wikiCode: "D2",
    name: "????????",
    summary: "Melee weapons under 1kg always trigger an additional melee hit using 40% of your base max hit (minimum of 1).",
    desc: "This will not trigger on special attacks",
    branch: "Melee",
    x: 1445, y: -444,
    requires: ["pact_b3"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_d3",
    wikiCode: "D3",
    name: "????????",
    summary: "Each melee attack with a heavy melee weapon (>=1kg) has a chance to trigger an instant Blindbag attack",
    desc: "",
    branch: "Melee",
    x: 1814, y: -47,
    requires: ["pact_b3"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_d4",
    wikiCode: "D4",
    name: "????????",
    summary: "Melee range is doubled whilst using two handed weapons",
    desc: "",
    branch: "Melee",
    x: 2010, y: 145,
    requires: ["pact_b3"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_da",
    wikiCode: "DA",
    name: "????????",
    summary: "+5 permanent Defence level boost",
    desc: "",
    branch: "",
    x: 1493, y: -908,
    requires: ["pact_d1"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_db",
    wikiCode: "DB",
    name: "????????",
    summary: "+15% accuracy in all combat styles",
    desc: "",
    branch: "",
    x: 1904, y: -545,
    requires: ["pact_d2", "pact_d3"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_dc",
    wikiCode: "DC",
    name: "????????",
    summary: "+15% accuracy in all combat styles",
    desc: "",
    branch: "",
    x: 2324, y: -151,
    requires: ["pact_d4"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_g1",
    wikiCode: "G1",
    name: "????????",
    summary: "While you have a shield equipped, you have a 0.1% chance per Defence level to reflect all damage back to the attacker",
    desc: "",
    branch: "",
    x: 1301, y: -1081,
    requires: ["pact_da"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_g2",
    wikiCode: "G2",
    name: "????????",
    summary: "Special attacks have a 20% chance to not consume any energy",
    desc: "",
    branch: "",
    x: 1705, y: -717,
    requires: ["pact_da", "pact_db"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_g3",
    wikiCode: "G3",
    name: "????????",
    summary: "+35% accuracy in all combat styles",
    desc: "",
    branch: "",
    x: 2121, y: -339,
    requires: ["pact_db", "pact_dc"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_g4",
    wikiCode: "G4",
    name: "Range Restore",
    summary: "Whenever you attack an enemy from at least 2 tiles away with any style, you restore 2% special attack energy",
    desc: "",
    branch: "",
    x: 2548, y: 53,
    requires: ["pact_dc", "pact_g12"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_g5",
    wikiCode: "G5",
    name: "????????",
    summary: "Attacking with a melee weapon or Thorns has a +10% chance to heal you based off your distance between you and your target (1 tile = 1 health)",
    desc: "",
    branch: "Melee",
    x: 1680, y: -1081,
    requires: ["pact_ga"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_g6",
    wikiCode: "G6",
    name: "Light Weapon Strength",
    summary: "Melee weapons that are under 1kg or one handed increase your melee strength by 20% of your Strength level",
    desc: "",
    branch: "Melee",
    x: 1904, y: -1300,
    requires: ["pact_g5", "pact_gb"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_g7",
    wikiCode: "G7",
    name: "Prayer Strength",
    summary: "Melee strength is increased by 50% of your worn prayer bonus",
    desc: "",
    branch: "Melee",
    x: 2059, y: -697,
    requires: ["pact_gb"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_g8",
    wikiCode: "G8",
    name: "Overheal Melee",
    summary: "Attacks with a melee weapon can consume 5 overhealed hitpoints (if available), increasing your minimum hit on that attack by 5",
    desc: "",
    branch: "Melee",
    x: 2294, y: -938,
    requires: ["pact_g7", "pact_gc"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_g9",
    wikiCode: "G9",
    name: "Two-Handed Echo",
    summary: "When hitting a target with a two handed melee weapon, you have a 5% chance to trigger a Ranged echo as if you have a bow, crossbow and thrown weapon equipped",
    desc: "",
    branch: "Melee",
    x: 2466, y: -299,
    requires: ["pact_gc"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_g10",
    wikiCode: "G10",
    name: "Distance Healing",
    summary: "Attacking with a melee weapon or Thorns has a +10% chance to heal you based off your distance between you and your target (1 tile = 1 health)",
    desc: "",
    branch: "Melee",
    x: 2680, y: -525,
    requires: ["pact_g9", "pact_gd"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_g11",
    wikiCode: "G11",
    name: "????????",
    summary: "+5 permanent Defence level boost",
    desc: "",
    branch: "",
    x: 996, y: -817,
    requires: ["pact_g1"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_g12",
    wikiCode: "G12",
    name: "????????",
    summary: "+5 permanent Defence level boost",
    desc: "",
    branch: "",
    x: 2548, y: 712,
    requires: ["pact_g4", "pact_bc"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_ga",
    wikiCode: "GA",
    name: "????????",
    summary: "+1% Melee damage",
    desc: "",
    branch: "Melee",
    x: 1564, y: -1331,
    requires: ["pact_g1"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_gb",
    wikiCode: "GB",
    name: "????????",
    summary: "+1% Melee damage",
    desc: "",
    branch: "Melee",
    x: 1953, y: -972,
    requires: ["pact_g2"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_gc",
    wikiCode: "GC",
    name: "????????",
    summary: "+1% Melee damage",
    desc: "",
    branch: "Melee",
    x: 2375, y: -591,
    requires: ["pact_g3"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_gd",
    wikiCode: "GD",
    name: "????????",
    summary: "+1% Melee damage",
    desc: "",
    branch: "Melee",
    x: 2762, y: -190,
    requires: ["pact_g4"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_f1",
    wikiCode: "F1",
    name: "????????",
    summary: "+35% accuracy in all combat styles",
    desc: "",
    branch: "",
    x: -1058, y: 53,
    requires: ["pact_ca"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_f2",
    wikiCode: "F2",
    name: "????????",
    summary: "Healing with Demonic Pacts overheals you, up to +30% of your base Hitpoints level",
    desc: "",
    branch: "Ranged",
    x: -652, y: -339,
    requires: ["pact_ca", "pact_cb"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_f3",
    wikiCode: "F3",
    name: "????????",
    summary: "+30% chance to Regenerate runes, ammo and charges",
    desc: "",
    branch: "Ranged",
    x: -253, y: -725,
    requires: ["pact_cb", "pact_cc"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_f4",
    wikiCode: "F4",
    name: "????????",
    summary: "+15 permanent Defence level boost",
    desc: "",
    branch: "Ranged",
    x: 127, y: -1081,
    requires: ["pact_cc", "pact_f12"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_f5",
    wikiCode: "F5",
    name: "Staff Water",
    summary: "Whenever you Regenerate charges from a powered staff or wand, also Regenerate 1 water rune",
    desc: "",
    branch: "Magic",
    x: -1004, y: -318,
    requires: ["pact_f6", "pact_fb"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_f6",
    wikiCode: "F6",
    name: "Staff Air",
    summary: "Whenever you Regenerate charges from a powered staff or wand, also Regenerate 1 air rune",
    desc: "",
    branch: "Magic",
    x: -1192, y: -525,
    requires: ["pact_fa", "pact_f5"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_f7",
    wikiCode: "F7",
    name: "Spell Speed",
    summary: "Attack rate with combat spells in a spellbook is sped up by 2 ticks.",
    desc: "This cannot reduce attack rate below 2 ticks (1.2s)",
    branch: "Magic",
    x: -773, y: -880,
    requires: ["pact_fb", "pact_fc"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_f8",
    wikiCode: "F8",
    name: "Staff Speed",
    summary: "Attack rate with powered staves is sped up by 3 ticks.",
    desc: "All one handed powered staves have their max hit reduced by 8. This cannot reduce attack rate below 1 tick (0.6s)",
    branch: "Magic",
    x: -575, y: -671,
    requires: ["pact_fb", "pact_fc"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_f9",
    wikiCode: "F9",
    name: "Staff Earth",
    summary: "Whenever you Regenerate charges from a powered staff or wand, also Regenerate 1 earth rune",
    desc: "",
    branch: "Magic",
    x: -189, y: -1045,
    requires: ["pact_f10", "pact_fd"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_f10",
    wikiCode: "F10",
    name: "Staff Fire",
    summary: "Whenever you Regenerate charges from a powered staff or wand, also Regenerate 1 fire rune",
    desc: "",
    branch: "Magic",
    x: -379, y: -1272,
    requires: ["pact_fc"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_f11",
    wikiCode: "F11",
    name: "????????",
    summary: "+5 permanent Defence level boost",
    desc: "",
    branch: "Ranged",
    x: -1058, y: 712,
    requires: ["pact_f1", "pact_bb"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_f12",
    wikiCode: "F12",
    name: "????????",
    summary: "+5 permanent Defence level boost",
    desc: "",
    branch: "Ranged",
    x: 426, y: -815,
    requires: ["pact_ba"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_f13",
    wikiCode: "F13",
    name: "????????",
    summary: "Healing with Demonic Pacts overheals you, up to +30% of your base Hitpoints level",
    desc: "",
    branch: "Ranged",
    x: 702, y: -1087,
    requires: ["pact_f12"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_fa",
    wikiCode: "FA",
    name: "????????",
    summary: "+1% Magic damage",
    desc: "(multiplied by Tumeken's Shadow special effect)",
    branch: "Magic",
    x: -1300, y: -190,
    requires: ["pact_f1", "pact_f6"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_fb",
    wikiCode: "FB",
    name: "????????",
    summary: "+1% Magic damage",
    desc: "(multiplied by Tumeken's Shadow special effect)",
    branch: "Magic",
    x: -864, y: -570,
    requires: ["pact_f2"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_fc",
    wikiCode: "FC",
    name: "????????",
    summary: "+1% Magic damage",
    desc: "(multiplied by Tumeken's Shadow special effect)",
    branch: "Magic",
    x: -464, y: -938,
    requires: ["pact_f3"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_fd",
    wikiCode: "FD",
    name: "????????",
    summary: "+1% Magic damage",
    desc: "(multiplied by Tumeken's Shadow special effect)",
    branch: "Magic",
    x: -98, y: -1314,
    requires: ["pact_f4"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_e1",
    wikiCode: "E1",
    name: "Bow Accuracy",
    summary: "While a bow is equipped, Ranged echoes never miss.",
    desc: "All bow pacts will not work with an Eclipse Atlatl",
    branch: "Range",
    x: 158, y: 1121,
    requires: ["pact_b2"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_e2",
    wikiCode: "E2",
    name: "Crossbow Echoes",
    summary: "While a crossbow is equipped, you have a +15% chance to trigger Ranged echoes",
    desc: "",
    branch: "Range",
    x: 723, y: 1123,
    requires: ["pact_b2"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_e3",
    wikiCode: "E3",
    name: "Thrown Weapon",
    summary: "While a thrown weapon is equipped, Ranged echoes have a 20% chance to max hit.",
    desc: "All thrown weapon pacts will not work with an Eclipse Atlatl",
    branch: "Range",
    x: 1301, y: 1126,
    requires: ["pact_b2"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_ea",
    wikiCode: "EA",
    name: "????????",
    summary: "+5 permanent Defence level boost",
    desc: "",
    branch: "",
    x: 157, y: 1470,
    requires: ["pact_e1"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_eb",
    wikiCode: "EB",
    name: "????????",
    summary: "+15% accuracy in all combat styles",
    desc: "",
    branch: "",
    x: 723, y: 1470,
    requires: ["pact_e2"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_ec",
    wikiCode: "EC",
    name: "????????",
    summary: "+5 permanent Defence level boost",
    desc: "",
    branch: "",
    x: 1301, y: 1470,
    requires: ["pact_e3"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_h1",
    wikiCode: "H1",
    name: "Range Accuracy",
    summary: "You have a 5% chance per attack in any style to roll max accuracy, this is increased by 5% for each tile distance between you and your target",
    desc: "",
    branch: "",
    x: -141, y: 1788,
    requires: ["pact_ea"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_h2",
    wikiCode: "H2",
    name: "????????",
    summary: "+30% chance to Regenerate runes, ammo and charges",
    desc: "",
    branch: "",
    x: 415, y: 1788,
    requires: ["pact_ea", "pact_eb"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_h3",
    wikiCode: "H3",
    name: "????????",
    summary: "+35% accuracy in all combat styles",
    desc: "",
    branch: "",
    x: 1008, y: 1788,
    requires: ["pact_eb", "pact_ec"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_h4",
    wikiCode: "H4",
    name: "Off-Hand",
    summary: "While an off-hand item is equipped, gain +5 melee strength, +5 ranged strength and +2% magic damage",
    desc: "",
    branch: "",
    x: 1602, y: 1788,
    requires: ["pact_ec"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_h5",
    wikiCode: "H5",
    name: "????????",
    summary: "+5 permanent Defence level boost",
    desc: "",
    branch: "",
    x: -414, y: 1470,
    requires: ["pact_ea", "pact_bb"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_h6",
    wikiCode: "H6",
    name: "Style Switch",
    summary: "Whenever you max hit from at least 3 tiles away, your next hit from a different style deals +25% damage",
    desc: "",
    branch: "",
    x: -695, y: 1729,
    requires: ["pact_h5"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_h7",
    wikiCode: "H7",
    name: "????????",
    summary: "All attacks have +15% Prayer penetration (up to 100%)",
    desc: "",
    branch: "",
    x: -977, y: 1470,
    requires: ["pact_h6", "pact_i6"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_h8",
    wikiCode: "H8",
    name: "????????",
    summary: "+5 permanent Defence level boost",
    desc: "",
    branch: "",
    x: 1863, y: 1470,
    requires: ["pact_ec", "pact_bc"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_h9",
    wikiCode: "H9",
    name: "????????",
    summary: "Healing with Demonic Pacts overheals you, up to +30% of your base Hitpoints level",
    desc: "",
    branch: "",
    x: 2170, y: 1740,
    requires: ["pact_h8", "pact_h10"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_h10",
    wikiCode: "H10",
    name: "????????",
    summary: "All attacks have +15% Prayer penetration (up to 100%)",
    desc: "",
    branch: "",
    x: 2473, y: 1470,
    requires: ["pact_h9", "pact_j6"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_ha",
    wikiCode: "HA",
    name: "????????",
    summary: "+1% Ranged damage",
    desc: "",
    branch: "Range",
    x: -141, y: 2107,
    requires: ["pact_h1"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_hb",
    wikiCode: "HB",
    name: "????????",
    summary: "+1% Ranged damage",
    desc: "",
    branch: "Range",
    x: 415, y: 2107,
    requires: ["pact_h2"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_hc",
    wikiCode: "HC",
    name: "????????",
    summary: "+1% Ranged damage",
    desc: "",
    branch: "Range",
    x: 1008, y: 2107,
    requires: ["pact_h3"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_hd",
    wikiCode: "HD",
    name: "????????",
    summary: "+1% Ranged damage",
    desc: "",
    branch: "Range",
    x: 1602, y: 2107,
    requires: ["pact_h4"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_i1",
    wikiCode: "I1",
    name: "Air Spells",
    summary: "Air spells deal +7% damage for each active prayer",
    desc: "",
    branch: "Magic",
    x: -1522, y: -414,
    requires: ["pact_fa"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_i2",
    wikiCode: "I2",
    name: "Water Spells",
    summary: "Water spells deal increased damage the higher health percentage you have (+20% damage at 100% health)",
    desc: "",
    branch: "Magic",
    x: -1074, y: -794,
    requires: ["pact_fb"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_i3",
    wikiCode: "I3",
    name: "Fire Spells",
    summary: "Fire spell casts burn up to 6% of your maximum Hitpoints to increase your damage dealt by double the amount burned for.",
    desc: "This effect cannot kill you directly",
    branch: "Magic",
    x: -674, y: -1159,
    requires: ["pact_fc"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_i4",
    wikiCode: "I4",
    name: "Earth Spells",
    summary: "Earth spell hits reduce the enemies Defence & Magic Defence levels by 2",
    desc: "",
    branch: "Magic",
    x: -316, y: -1508,
    requires: ["pact_fd"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_i5",
    wikiCode: "I5",
    name: "????????",
    summary: "All attacks have +15% Prayer penetration (up to 100%)",
    desc: "",
    branch: "Ranged",
    x: -1522, y: 1174,
    requires: ["pact_i1", "pact_k5"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_i6",
    wikiCode: "I6",
    name: "Prayer Restore",
    summary: "While protection prayers are not active, you restore 1 Prayer point every 15 ticks (9s), this is sped up by 1 tick (0.6s) for every 7 worn prayer bonus you have",
    desc: "",
    branch: "Ranged",
    x: -695, y: 1174,
    requires: ["pact_i5", "pact_h7"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_i7",
    wikiCode: "I7",
    name: "????????",
    summary: "All attacks have +15% Prayer penetration (up to 100%)",
    desc: "",
    branch: "Ranged",
    x: 291, y: -1923,
    requires: ["pact_i4", "pact_j7"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_ia",
    wikiCode: "IA",
    name: "????????",
    summary: "+1% Magic damage",
    desc: "(multiplied by Tumeken's Shadow special effect)",
    branch: "Magic",
    x: -1744, y: -640,
    requires: ["pact_i1"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_ib",
    wikiCode: "IB",
    name: "????????",
    summary: "+1% Magic damage",
    desc: "(multiplied by Tumeken's Shadow special effect)",
    branch: "Magic",
    x: -1267, y: -996,
    requires: ["pact_i2"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_ic",
    wikiCode: "IC",
    name: "????????",
    summary: "+1% Magic damage",
    desc: "(multiplied by Tumeken's Shadow special effect)",
    branch: "Magic",
    x: -891, y: -1373,
    requires: ["pact_i3"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_id",
    wikiCode: "ID",
    name: "????????",
    summary: "+1% Magic damage",
    desc: "(multiplied by Tumeken's Shadow special effect)",
    branch: "Magic",
    x: -527, y: -1711,
    requires: ["pact_i4"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_k1",
    wikiCode: "K1",
    name: "Ranged Prayer",
    summary: "Ranged prayers are 30% more effective",
    desc: "",
    branch: "Range",
    x: 127, y: 2107,
    requires: ["pact_ha", "pact_hb"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_k2",
    wikiCode: "K2",
    name: "Health Strength",
    summary: "Ranged strength is increased by 1 for every 10 hitpoints difference between your current hitpoints and Hitpoints level",
    desc: "",
    branch: "Range",
    x: 723, y: 2107,
    requires: ["pact_hb", "pact_hc"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_k3",
    wikiCode: "K3",
    name: "Echo Cascade",
    summary: "Ranged echoes can now trigger additional Ranged echoes at half your chance to trigger them (up to 4 times)",
    desc: "",
    branch: "Range",
    x: 1301, y: 2107,
    requires: ["pact_hc", "pact_hd"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_k4",
    wikiCode: "K4",
    name: "Bow Speed",
    summary: "Bows attack 1 tick (0.6s) faster",
    desc: "",
    branch: "Range",
    x: -141, y: 2394,
    requires: ["pact_ha"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_k5",
    wikiCode: "K5",
    name: "????????",
    summary: "All attacks have +15% Prayer penetration (up to 100%)",
    desc: "",
    branch: "",
    x: -1522, y: 2394,
    requires: ["pact_k4", "pact_i5"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_k6",
    wikiCode: "K6",
    name: "Thrown Weapon Strength",
    summary: "While a thrown weapon is equipped, ranged strength is also increased by your 80% of your melee strength",
    desc: "",
    branch: "Range",
    x: 1602, y: 2394,
    requires: ["pact_hd"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_k7",
    wikiCode: "K7",
    name: "????????",
    summary: "All attacks have +15% Prayer penetration (up to 100%)",
    desc: "",
    branch: "",
    x: 3037, y: 2394,
    requires: ["pact_k6"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_k8",
    wikiCode: "K8",
    name: "Crossbow Power",
    summary: "Crossbows attack 2 ticks (1.2s) slower, but deal +70% damage",
    desc: "",
    branch: "Range",
    x: 723, y: 2394,
    requires: ["pact_hb", "pact_hc"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_k9",
    wikiCode: "K9",
    name: "????????",
    summary: "Whenever you Regenerate ammo, you have a +5% chance to fire a Ranged echo against the enemy",
    desc: "",
    branch: "Range",
    x: 260, y: 2792,
    requires: ["pact_ka", "pact_kb"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_k10",
    wikiCode: "K10",
    name: "Echo Chance",
    summary: "Whenever you Regenerate ammo, you have a +5% chance to fire a Ranged echo against the enemy",
    desc: "",
    branch: "Range",
    x: 1203, y: 2792,
    requires: ["pact_kc", "pact_kb"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_ka",
    wikiCode: "KA",
    name: "????????",
    summary: "+1% Ranged damage",
    desc: "",
    branch: "Range",
    x: -141, y: 2712,
    requires: ["pact_k4", "pact_k9"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_kb",
    wikiCode: "KB",
    name: "????????",
    summary: "+1% Ranged damage",
    desc: "",
    branch: "Range",
    x: 723, y: 2712,
    requires: ["pact_k8", "pact_k9", "pact_k10"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_kc",
    wikiCode: "KC",
    name: "????????",
    summary: "+1% Ranged damage",
    desc: "",
    branch: "Range",
    x: 1602, y: 2712,
    requires: ["pact_k6", "pact_k10"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_n1",
    wikiCode: "N1",
    name: "????????",
    summary: "+1% Ranged damage",
    desc: "",
    branch: "Range",
    x: -141, y: 3086,
    requires: ["pact_ka"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_n2",
    wikiCode: "N2",
    name: "????????",
    summary: "+1% Ranged damage",
    desc: "",
    branch: "Range",
    x: 723, y: 3086,
    requires: ["pact_kb"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_n3",
    wikiCode: "N3",
    name: "????????",
    summary: "+1% Ranged damage",
    desc: "",
    branch: "Range",
    x: 1602, y: 3086,
    requires: ["pact_kc"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_n4",
    wikiCode: "N4",
    name: "Bow Minimum",
    summary: "Hitting with a bow increases your bows minimum hit by 1, capping at 15% of your base maximum hit.",
    desc: "This bonus is halved when you take damage that you didn't or couldn't pray against",
    branch: "Range",
    x: -414, y: 3344,
    requires: ["pact_n1"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_n5",
    wikiCode: "N5",
    name: "Bow Maximum",
    summary: "Hitting with a bow increases your bows maximum hit by 1, capping at 15% of your base maximum hit.",
    desc: "This bonus is halved when you take damage that you didn't or couldn't pray against",
    branch: "Range",
    x: 127, y: 3344,
    requires: ["pact_n1"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_n6",
    wikiCode: "N6",
    name: "Crossbow",
    summary: "Crossbow hits always max hit",
    desc: "",
    branch: "Range",
    x: 446, y: 3344,
    requires: ["pact_n2"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_n7",
    wikiCode: "N7",
    name: "Crossbow Accuracy",
    summary: "Crossbows attacks roll accuracy twice",
    desc: "",
    branch: "Range",
    x: 1008, y: 3344,
    requires: ["pact_n2"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_n8",
    wikiCode: "N8",
    name: "Thrown Weapon Accuracy",
    summary: "While a thrown weapon is equipped, increase your ranged accuracy by 60",
    desc: "",
    branch: "Range",
    x: 1342, y: 3344,
    requires: ["pact_n3"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_n9",
    wikiCode: "N9",
    name: "Thrown Weapon Multi-Target",
    summary: "When attacking with a thrown weapon, you now throw at an additional nearby target",
    desc: "",
    branch: "Range",
    x: 1863, y: 3344,
    requires: ["pact_n3"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_j1",
    wikiCode: "J1",
    name: "Recoil Damage",
    summary: "All recoil & Thorns style effects deal additional damage equal to 1% of your total defence bonuses",
    desc: "",
    branch: "Melee",
    x: 1808, y: -1573,
    requires: ["pact_ga"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_j2",
    wikiCode: "J2",
    name: "Light Weapon Speed",
    summary: "Melee weapons under 1kg attack 1 tick (0.6s) faster",
    desc: "",
    branch: "Melee",
    x: 2193, y: -1247,
    requires: ["pact_gb"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_j3",
    wikiCode: "J3",
    name: "Blindbag Triggers",
    summary: "For each unique heavy melee weapon (>=1kg) in your inventory, your chance of a Blindbag trigger is increased by 2% up to a maximum of 10% (5 weapons)",
    desc: "",
    branch: "Melee",
    x: 2635, y: -851,
    requires: ["pact_gc"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_j4",
    wikiCode: "J4",
    name: "Distance Strength",
    summary: "Your maximum hit when attacking with a melee weapon is increased by 4% and an additional 4% for every 3 tiles of distance between you and your target",
    desc: "",
    branch: "Melee",
    x: 3040, y: -501,
    requires: ["pact_gd"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_j5",
    wikiCode: "J5",
    name: "????????",
    summary: "All attacks have +15% Prayer penetration (up to 100%)",
    desc: "",
    branch: "",
    x: 3032, y: 1169,
    requires: ["pact_k7", "pact_j4", "pact_j6"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_j6",
    wikiCode: "J6",
    name: "????????",
    summary: "+30% chance to Regenerate runes, ammo and charges",
    desc: "",
    branch: "",
    x: 2165, y: 1185,
    requires: ["pact_j5", "pact_h10"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_j7",
    wikiCode: "J7",
    name: "????????",
    summary: "All attacks have +15% Prayer penetration (up to 100%)",
    desc: "",
    branch: "",
    x: 1092, y: -1923,
    requires: ["pact_j1", "pact_j8", "pact_i7"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_j8",
    wikiCode: "J8",
    name: "Block Heal",
    summary: "Whenever an attack deals 0 damage to you while either a two-handed shield or an off-hand is equipped, you're healed for 2 and restore 2 prayer points",
    desc: "",
    branch: "",
    x: 656, y: -1552,
    requires: ["pact_j9", "pact_j7"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_j9",
    wikiCode: "J9",
    name: "????????",
    summary: "All attacks have +15% Prayer penetration (up to 100%)",
    desc: "",
    branch: "",
    x: 433, y: -1327,
    requires: ["pact_f13"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_ja",
    wikiCode: "JA",
    name: "????????",
    summary: "+1% Melee damage",
    desc: "",
    branch: "Melee",
    x: 2110, y: -1874,
    requires: ["pact_j1"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_jb",
    wikiCode: "JB",
    name: "????????",
    summary: "+1% Melee damage",
    desc: "",
    branch: "Melee",
    x: 2500, y: -1555,
    requires: ["pact_j2"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_jc",
    wikiCode: "JC",
    name: "????????",
    summary: "+1% Melee damage",
    desc: "",
    branch: "Melee",
    x: 2928, y: -1163,
    requires: ["pact_j3"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_jd",
    wikiCode: "JD",
    name: "????????",
    summary: "+1% Melee damage",
    desc: "",
    branch: "Melee",
    x: 3326, y: -807,
    requires: ["pact_j4"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_l1",
    wikiCode: "L1",
    name: "Air Spells",
    summary: "Air spells have a +1% chance to max hit for every 1 prayer bonus, this chance is doubled against enemies weak to air spells",
    desc: "",
    branch: "Magic",
    x: -2073, y: -964,
    requires: ["pact_ia"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_l2",
    wikiCode: "L2",
    name: "Water Spells",
    summary: "Water spell hits bounce back to you, healing you for the 60% of the damage dealt to your target",
    desc: "",
    branch: "Magic",
    x: -1597, y: -1350,
    requires: ["pact_ib"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_l3",
    wikiCode: "L3",
    name: "Fire Spells",
    summary: "Fire spell hits apply 1 burn (max 5) and bounce to up to 2 nearby targets",
    desc: "",
    branch: "Magic",
    x: -1223, y: -1715,
    requires: ["pact_ic"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_l4",
    wikiCode: "L4",
    name: "Earth Spells",
    summary: "Earth spells deal additional flat damage based on your current Defence level (+1 damage per 12 Defence levels)",
    desc: "",
    branch: "Magic",
    x: -847, y: -2016,
    requires: ["pact_id"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_l5",
    wikiCode: "L5",
    name: "Smoke Element",
    summary: "Smoke spells now count as 'air' spells",
    desc: "",
    branch: "Magic",
    x: -1522, y: -837,
    requires: ["pact_ia"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_l6",
    wikiCode: "L6",
    name: "Ice Element",
    summary: "Ice spells now count as 'water' spells",
    desc: "",
    branch: "Magic",
    x: -971, y: -1098,
    requires: ["pact_ib"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_l7",
    wikiCode: "L7",
    name: "Blood Element",
    summary: "Blood spells now count as 'fire' spells",
    desc: "",
    branch: "Magic",
    x: -1170, y: -1314,
    requires: ["pact_ic"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_l8",
    wikiCode: "L8",
    name: "Shadow Element",
    summary: "Shadow spells now count as 'earth' spells",
    desc: "",
    branch: "Magic",
    x: -695, y: -1553,
    requires: ["pact_id"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_m1",
    wikiCode: "M1",
    name: "Thorns",
    summary: "When the Thorns effect triggers, it will always hit twice, dealing 50% of its damage in the second hit",
    desc: "",
    branch: "Melee",
    x: 2343, y: -2108,
    requires: ["pact_ja"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_m2",
    wikiCode: "M2",
    name: "Melee Weapon",
    summary: "Whenever you deal damage with a melee weapon, you restore 2% special attack energy per hit",
    desc: "",
    branch: "Melee",
    x: 2735, y: -1791,
    requires: ["pact_jb"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_m3",
    wikiCode: "M3",
    name: "Blindbag",
    summary: "For each unique heavy melee weapon (>=1kg) in your inventory, the max hit of your Blindbag attacks is increased by 2% up to a maximum of 10% (5 weapons)",
    desc: "",
    branch: "Melee",
    x: 3176, y: -1421,
    requires: ["pact_jc"],
    skills: {},
    effect: {},
  },

  {
    id: "pact_m4",
    wikiCode: "M4",
    name: "Halberd Range",
    summary: "If your melee attack range is at least 4, it is increased to 7.",
    desc: "All halberds slower than 5 ticks have their attack rate set to 5 ticks (3.0s)",
    branch: "Melee",
    x: 3556, y: -1054,
    requires: ["pact_jd"],
    skills: {},
    effect: {},
  },

];

// Legacy export for computeScores compatibility
export const MASTERIES = { Melee: [], Range: [], Magic: [], Passives: [] };

export const PACT_ICONS = {
  AA: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  B1: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/y618dq21t123dat/O0hd17td1.png',
  B2: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/y618dq21t123dat/O0hfdqa1g9.png',
  B3: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/y618dq21t123dat/O0y61e2g2e1.png',
  BA: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  BB: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  BC: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  C1: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/t87eghq12e11/e0247628a2e3e3df.png',
  C2: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/t87eghq12e11/df5398992ce071dd.png',
  C3: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/t87eghq12e11/6c55c4b6afb75c8b.png',
  C4: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/t87eghq12e11/f8275e2b85d15c7b.png',
  CA: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  CB: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  CC: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  D1: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/rfd1e2612h22ff/1f1a8beb6bd363f7.png',
  D2: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/rfd1e2612h22ff/be95f5cdf152b930.png',
  D3: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/rfd1e2612h22ff/9a020da9b7b95414.png',
  D4: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/rfd1e2612h22ff/7f9583b9c6a21a0d.png',
  DA: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  DB: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  DC: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  G1: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/a6aghr82h371jhr91d1/b1fa048e3f7e4270.png',
  G2: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/a6aghr82h371jhr91d1/686d89fdd4458da0.png',
  G3: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/7731871873g178138913/b3f5137e595e1463.png',
  G4: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/a6aghr82h371jhr91d1/32fa2e41eefa1332.png',
  G5: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/a6aghr82h371jhr91d1/7f0bb02d8d2b4784.png',
  G6: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/a6aghr82h371jhr91d1/3263e47a58ba8c93.png',
  G7: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/a6aghr82h371jhr91d1/b060fd1201774fdb.png',
  G8: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/a6aghr82h371jhr91d1/2fde372419555039.png',
  G9: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/a6aghr82h371jhr91d1/fe388647a3c5a17b.png',
  G10: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/a6aghr82h371jhr91d1/7f0bb02d8d2b4784.png',
  G11: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/7731871873g178138913/1b5a5e157ffc7b67.png',
  G12: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/7731871873g178138913/1b5a5e157ffc7b67.png',
  GA: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  GB: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  GC: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  GD: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  F1: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/7731871873g178138913/b3f5137e595e1463.png',
  F2: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/7731871873g178138913/x8zgfa5199aha561safgb.png',
  F3: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/7731871873g178138913/e40a19488c4be865.png',
  F4: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/7731871873g178138913/1b5a5e157ffc7b67.png',
  F5: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/7731871873g178138913/091gs71gs651f1s1fr.png',
  F6: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/7731871873g178138913/61fs101ywgsys12t1hs.png',
  F7: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/7731871873g178138913/e881a6002f45a959.png',
  F8: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/7731871873g178138913/daw76d1g8dasdh21.png',
  F9: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/7731871873g178138913/8vabasc561g1cbca1.png',
  F10: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/7731871873g178138913/867asdw1231318ddsa2.png',
  F11: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/7731871873g178138913/1b5a5e157ffc7b67.png',
  F12: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/7731871873g178138913/1b5a5e157ffc7b67.png',
  F13: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/7731871873g178138913/x8zgfa5199aha561safgb.png',
  FA: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  FB: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  FC: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  FD: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  E1: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/hdawdaw82hsas/7f40be70ae08ad7d.png',
  E2: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/hdawdaw82hsas/178027e2bba60fcf.png',
  E3: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/hdawdaw82hsas/509fac10715b7c2e.png',
  EA: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  EB: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  EC: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  H1: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/7731871873g178138913/b3f5137e595e1463.png',
  H2: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/7731871873g178138913/e40a19488c4be865.png',
  H3: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/7731871873g178138913/b3f5137e595e1463.png',
  H4: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/77127813cbncccc111s/1fe7ec41b5ab2cdf.png',
  H5: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/7731871873g178138913/1b5a5e157ffc7b67.png',
  H6: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/77127813cbncccc111s/7a1d2cb5b360ea7d.png',
  H7: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/jd12eyh19e123e1/e01297577dea5871.png',
  H8: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/7731871873g178138913/1b5a5e157ffc7b67.png',
  H9: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/7731871873g178138913/x8zgfa5199aha561safgb.png',
  H10: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/jd12eyh19e123e1/e01297577dea5871.png',
  HA: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  HB: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  HC: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  HD: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  I1: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/jd12eyh19e123e1/812hg27876yhs981h1f.png',
  I2: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/jd12eyh19e123e1/97bdad20685e1194.png',
  I3: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/jd12eyh19e123e1/a77463492fba91ed.png',
  I4: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/jd12eyh19e123e1/830a1dc6c5b74be8.png',
  I5: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/jd12eyh19e123e1/e01297577dea5871.png',
  I6: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/jd12eyh19e123e1/e01297577dea5871.png',
  I7: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/jd12eyh19e123e1/e01297577dea5871.png',
  IA: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  IB: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  IC: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  ID: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  K1: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/7778123y712hg12daqwd12/d1a416943b9f9511.png',
  K2: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/7778123y712hg12daqwd12/58d87cbbb16c8b3b.png',
  K3: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/7778123y712hg12daqwd12/cface89d1b6ace48.png',
  K4: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/7778123y712hg12daqwd12/0ab9356c6a5f7ca6.png',
  K5: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/jd12eyh19e123e1/e01297577dea5871.png',
  K6: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/7778123y712hg12daqwd12/4b026b40174aca6d.png',
  K7: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/jd12eyh19e123e1/e01297577dea5871.png',
  K8: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/7778123y712hg12daqwd12/1100cd38ee7e385f.png',
  K9: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/y618dq21t123dat/O0hfdqa1g9.png',
  K10: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/y618dq21t123dat/O0hfdqa1g9.png',
  KA: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  KB: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  KC: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  N1: 'https://cdn.runescape.com/assets/img/external/oldschool/6202/hhjiala19194j41o0/17ad64b734c3fca2.png',
  N2: 'https://cdn.runescape.com/assets/img/external/oldschool/6202/hhjiala19194j41o0/17ad64b734c3fca2.png',
  N3: 'https://cdn.runescape.com/assets/img/external/oldschool/6202/hhjiala19194j41o0/17ad64b734c3fca2.png',
  N4: 'https://cdn.runescape.com/assets/img/external/oldschool/6202/hhjiala19194j41o0/5c83a4b4570c7a5c.png',
  N5: 'https://cdn.runescape.com/assets/img/external/oldschool/6202/hhjiala19194j41o0/8d017673eedd2c1a.png',
  N6: 'https://cdn.runescape.com/assets/img/external/oldschool/6202/hhjiala19194j41o0/23b51fe158afba5a.png',
  N7: 'https://cdn.runescape.com/assets/img/external/oldschool/6202/hhjiala19194j41o0/d07d3e8251655897.png',
  N8: 'https://cdn.runescape.com/assets/img/external/oldschool/6202/hhjiala19194j41o0/eb7a5c223e13c541.png',
  N9: 'https://cdn.runescape.com/assets/img/external/oldschool/6202/hhjiala19194j41o0/28e40109e4a76288.png',
  J1: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/gd7192g1ewdwaw/166gvd81hd5mlpaj1a.png',
  J2: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/gd7192g1ewdwaw/8a7345247f43c110.png',
  J3: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/gd7192g1ewdwaw/7172753d54d82285.png',
  J4: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/gd7192g1ewdwaw/8b8fbaaa9fb2f03f.png',
  J5: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/jd12eyh19e123e1/e01297577dea5871.png',
  J6: 'https://cdn.runescape.com/assets/img/external/oldschool/2025/7731871873g178138913/e40a19488c4be865.png',
  J7: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/jd12eyh19e123e1/e01297577dea5871.png',
  J8: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/gd7192g1ewdwaw/1f73f27481a20857.png',
  J9: 'https://cdn.runescape.com/assets/img/external/oldschool/20XX/jd12eyh19e123e1/e01297577dea5871.png',
  JA: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  JB: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  JC: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  JD: 'https://cdn.runescape.com/assets/img/external/oldschool/2026/toor/xyzuvwrst.png',
  L1: 'https://cdn.runescape.com/assets/img/external/oldschool/6202/dgg17g2e12e1d12e/f73898e27e8fbdc1.png',
  L2: 'https://cdn.runescape.com/assets/img/external/oldschool/6202/dgg17g2e12e1d12e/5ae944c8d7985f96.png',
  L3: 'https://cdn.runescape.com/assets/img/external/oldschool/6202/dgg17g2e12e1d12e/c8173d7d8268533a.png',
  L4: 'https://cdn.runescape.com/assets/img/external/oldschool/6202/dgg17g2e12e1d12e/37c212549b2225e9.png',
  L5: 'https://cdn.runescape.com/assets/img/external/oldschool/6202/dgg17g2e12e1d12e/2e6e06f7aef59caf.png',
  L6: 'https://cdn.runescape.com/assets/img/external/oldschool/6202/dgg17g2e12e1d12e/6e013c2042627615.png',
  L7: 'https://cdn.runescape.com/assets/img/external/oldschool/6202/dgg17g2e12e1d12e/cc89d439d58b6571.png',
  L8: 'https://cdn.runescape.com/assets/img/external/oldschool/6202/dgg17g2e12e1d12e/83c1949ddf1b4149.png',
  M1: 'https://cdn.runescape.com/assets/img/external/oldschool/6202/jdjgvbcmxoaodwij114r51/7hawd51fd90kbcbmn1.png',
  M2: 'https://cdn.runescape.com/assets/img/external/oldschool/6202/jdjgvbcmxoaodwij114r51/64931a5b89a31b08.png',
  M3: 'https://cdn.runescape.com/assets/img/external/oldschool/6202/jdjgvbcmxoaodwij114r51/08a8fbdad1587d62.png',
  M4: 'https://cdn.runescape.com/assets/img/external/oldschool/6202/jdjgvbcmxoaodwij114r51/542d10b024fa96e3.png',
};
